module.exports = {
  port: 3012,
  database: {
    url: process.env.MICROSERVICE1_TESTING_DB_URL || ""
  },
}



// WEBPACK FOOTER //
// /Users/james/code/nextlevel/config/backend/testing/microservice1.js